export default "__VITE_ASSET__0ff82f87__"